<div *ngFor="let attribute of visibleAttributes; trackBy attributeTrackFn; let last = last"
     [ngClass]="last && !product?.hasSizeCrosssells ? 'p-b-2 p-b-3-s' : 'p-b-8'">
    @if (isHuge){
    <div class="flex flex-middle flex-justify-between">
        <div>
            <span class="s2">{{'Colour' | translate }}: </span>

            <span class="p2">
                @if (product.data.parent && product.data.variant_attribute_1) {
                {{product.variantAttribute1}}
                }
                @if (!product.data.parent && product.data.web_finish) {
                {{product.data.web_finish}}
                }</span>
        </div>
        @if(!upsellVariant){
        <product-view-samples *ifSize="'!S'"
                              [product]="product"
                              class="block"></product-view-samples>
        }
    </div>
    }

    <swatch [image]="option.product ? (option.product.data?.media | findMediaByLabel : 'swatch') : undefined"
            [isHuge]="isHuge"
            [isRound]="true"
            *ngFor="let option of attribute.options; trackBy optionTrackFn"
            (click)="pick(attribute, option)"
            [selected]="isPicked(attribute, option)"
            [disabled]="!option.product?.isSalable()"
            class="inline-block va-m cursor-pointer m-r-2 m-t-3"></swatch>
    <ng-container *ngIf="product.hasColorCrosssells">
        <div class="inline-block va-m m-r-2 m-t-3 cursor-pointer"
             *ngFor="let crossSellProduct of product.colorCrossSellProducts; trackBy: trackByProductId"
             (click)="crossellProductClick.next(crossSellProduct)">
            <href [link]="!noCrossellLink && crossSellProduct.data.url">
                <swatch [attributeCode]="'config_colour'"
                        [value]="crossSellProduct.data.config_colour"
                        [isHuge]="isHuge"
                        [isRound]="true"
                        [selected]="false"
                        [disabled]="false"></swatch>
            </href>
        </div>
    </ng-container>
</div>
